import { apiAxios } from "../apiConfig";

// Email signup
export const emailSignup = async (payload) => {
  try {
    const response = await apiAxios.post("/emails", payload);
    return response.data;
  } catch (error) {
    console.error("Error signing up email:", error);
    throw error;
  }
};
